import { useMediaQuery } from 'react-responsive';
import { Redirect, useLocation } from 'react-router-dom';
import { THEME } from '../../web/components-v2/Theme/theme';

/** The only routes Coffee has laid out for a phone. */
const MOBILE_ROUTES = ['/call-log', '/leaderboard', '/ai-coaching-review'];

const MOBILE_FALLBACK_ROUTE = '/call-log';

export const isCoffeeMobileRoute = (pathname: string) =>
	MOBILE_ROUTES.some(route => pathname.toLowerCase().startsWith(route));

export const useIsCoffeeMobile = () => useMediaQuery({ maxWidth: THEME.breakpoints.md });

export const CoffeeMobileRouteGuard = () => {
	const { pathname } = useLocation();
	const isMobile = useIsCoffeeMobile();
	return isMobile && !isCoffeeMobileRoute(pathname) ? <Redirect to={MOBILE_FALLBACK_ROUTE} /> : null;
};
